import React from 'react';

import {cn} from '../lib/helpers';

import {logoIconWrapper, logoIconSvg} from './logoIcon.module.css';

const LogoIcon = ({className, ...rest}) => (
  <div className={cn(logoIconWrapper, className)} {...rest}>
    <svg
      className={logoIconSvg}
      viewBox="0 0 128 80"
      preserveAspectRatio="none"
    >
      <path
        d="M26.62 43.16V0H0v43.5c0 26 14.89 36.8 38 37V57.11c-6.69-.28-11.38-4.49-11.38-13.95zm24.16.57c0 9.33-4.78 13.19-11.55 13.39v23.33c23-.22 38.17-10.87 38.17-37.51V0H50.78zM81.36 0h-2.64v23h3.2c12 0 19.68 5 19.68 16.34v.23c0 11.38-7.71 16.34-19.68 16.34h-2.78v23h1.32C112.12 78.89 128 62.32 128 39v-.22C128 15.44 112.45 0 81.36 0z"
        fillRule="evenodd"
        fill="#FFF"
      />
    </svg>
  </div>
);

export default LogoIcon;
